export default __webpack_public_path__ + "static/media/Chirag R. Kathrani.30cf7ed9.jpg";